
import { ModalHandler } from '../mixins/ModalHandler'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter, Action } from 'vuex-class'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import Button from 'umg-components/src/components/atoms/Button.vue'
import Headline from 'umg-components/src/components/atoms/Headline.vue'
import Paragraph from 'umg-components/src/components/atoms/Paragraph.vue'
import Icon from 'umg-components/src/components/atoms/Icon.vue'
import Modal from 'umg-components/src/components/molecules/Modal.vue'
import Card from 'umg-components/src/components/molecules/Card.vue'
import AssetServiceLogin from './AssetServiceLogin.vue'
import { cms } from '../../cms'

@Component({
  components: {
    AssetServiceLogin,
    Button,
    Modal,
    Paragraph,
    Headline,
    Icon,
    Card,
  },
})
export default class LoginModal extends Mixins(TranslationHandler, ModalHandler) {
  @Prop() service!: string

  @Getter visualPrimaryColor!: string
  @Getter visualIsDark!: boolean
  @Getter visualTextColor!: string
  @Getter visualFont!: string
  @Getter visualButtonTextColor!: string

  @Getter userService!: string
  @Getter userIsSubscribed!: boolean
  @Getter partyLoginRequired!: boolean

  @Action('USER_PARTY_LOAD') loadPartyUser!: () => Promise<void>
  @Action('USER_LOGIN') userLogin!: (p: { service: string, artistIds: string[] }) => Promise<boolean>

  get serviceName() {
    switch (this.service) {
      case 'spotify': {
        return 'Spotify'
      }
      case 'apple': {
        return 'Apple'
      }
      case 'deezer': {
        return 'Deezer'
      }
      default: {
        return ''
      }
    }
  }

  get translations() {
    return {
      title: this.$t(`loginModal${this.serviceName}Title`),
      text: this.$t(`loginModal${this.serviceName}Text`),
      buttonOpen: this.$t('loginModalButtonOpen'),
      buttonClose: this.$t('loginModalButtonClose'),
      noLogin: this.$t('registerNoLogin'),
    }
  }

  get background(): string {
    return this.visualIsDark ? '#141418' : '#F5F5FF'
  }

  async login() {
    cms.tracking.trackCustomer('login_start', { login_method: this.service })
    await this.userLogin({
      artistIds: [],
      service: this.service,
    })

    if (this.userService === 'spotify') return // TODO: Is this needed?

    if (this.userIsSubscribed) {
      this.$router.push({ name: 'Player' })
    } else {
      this.$router.push({ name: 'Register' })
    }
  }
}
